import React from "react";

export const Impressum = () => {
  return (
    <div id="impressum" className="text-center">
      <div className="container">
        <div className="col-md-10 col-md-offset-1 section-title">
          <h2>Impressum</h2>
          <p>
            Helene Luise Köppel,
            <br />
            Lindenstr. 9,
            <br />
            97424 Schweinfurt,
            <br />
            E-Mail: helenekoeppel@googlemail.com <br />
            Inhaltlich verantwortlich gem § 18 Abs. 2 MstV: Helene Köppel
            <br />
            Alle Angaben wurden sorgfältig geprüft. Dessen ungeachtet kann eine
            Garantie für die Vollständigkeit, Richtigkeit und letzte Aktualität
            nicht übernommen werden.
          </p>
          <br />
          <center>
            <img
              src={"bilder/impressum.jpg"}
              className="img-responsive"
              alt={"Die Künstlerin malt.."}
            />
          </center>
        </div>
      </div>
    </div>
  );
};
